export const filterGenders = (inflectionScheme) => {
  const firstCasusKey = Object.keys(inflectionScheme)[0];
  const schemeGenders = Object.keys(inflectionScheme[firstCasusKey]);

  return ["masculine", "feminine", "neutral"].filter((gender) => schemeGenders.includes(gender));
};
